<template>
  <div class="manage_pla">
    <div class="banner">
      <div class="inner">
        <h2>Management</h2>
        <p>介绍</p>
        <button @click="goToContact(2)" class="inner-le">Eco-cooperation</button>
        <button style="margin-left: 3em;" @click="goToContact(3)" class="inner-ri">Contact us</button>
      </div>
    </div>
  </div>
</template>

<script setup name="Mannage_platform">
import { onMounted } from 'vue';
onMounted(() => {
  window.scrollTo(0, 0);
})
const emit = defineEmits(['scroll-to-contact'])
function goToContact(type) {
  emit('scroll-to-contact', type)
}
</script>

<style scoped>
.banner{
  position: relative;
  width: 100%;
  height: 25em;
  background-color: #ddd;
  margin-bottom: 8em;
}
.banner .inner{
  position: absolute;
  top:15%;
  left:10%;
}
.inner-le,.inner-ri{
  position: absolute;
  width: 8em;
  height: 3em;
  border-radius: 1.5em;
  top:18em;
  border:transparent;
  cursor: pointer;
}
.inner-le{
  background-color: orange;
  left:3em;
  color: white;
}
.inner-ri{
  background-color: skyblue;
  color: white;
  left:11em;
}
</style>